module.exports = __webpack_public_path__ + "/content/skins/m-logic/fav/mstile-310x310.png";